import axios from 'axios';
const baseURL = process.env.VUE_APP_API_URL  || "https://antibiomic.com/api";
console.log('baseURL', baseURL);
// Create axios instance with base URL
const api = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api; 